export enum PulseBetsTypes {
    ThirtySecPulse = "1441",
    OneMinPulse = "1442",
    FiveMinPulse = "1443",
    TenMinPulse = "1444"
}